import { ContractDetailsView } from "./details/ContractDetailsView";
import { ContractsView } from "./list/ContractsView";

export const views = {
  contracts: ContractsView,
  "contracts.details": ContractDetailsView,
};
